import { render, staticRenderFns } from "./FieldOverviewStatistics.vue?vue&type=template&id=5debaee5&scoped=true&"
import script from "./FieldOverviewStatistics.vue?vue&type=script&lang=js&"
export * from "./FieldOverviewStatistics.vue?vue&type=script&lang=js&"
import style0 from "./FieldOverviewStatistics.vue?vue&type=style&index=0&id=5debaee5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5debaee5",
  null
  
)

export default component.exports